const veeConfig = {
    errorBagName: 'errors', // change if property conflicts
    fieldsBagName: 'fields',
    delay: 0,
    locale: 'en',
    dictionary: null,
    strict: true,
    classes: false,
    classNames: {
        touched: 'touched', // the control has been blurred
        untouched: 'untouched', // the control hasn't been blurred
        valid: 'valid', // model is valid
        invalid: 'invalid', // model is invalid
        pristine: 'pristine', // control has not been interacted with
        dirty: 'dirty' // control has been interacted with
    },
    events: '',
    inject: true,
    validity: false,
    aria: true
};
import Vue from 'vue'
Vue.use(require('vee-validate'), veeConfig);

/******* Validator functions ********/
import { Validator } from 'vee-validate';
Validator.extend('phone', {
    getMessage: function(field, params, data) {
        return '';
    },
    validate: function(value) {
        value = value.replace(/ /g, '');
        value = value.replace(/\(/g, '');
        value = value.replace(/\)/g, '');

        let valid = false;
        if (value.match(/^(00([1-9]{2})|0([1-9]{2})|\+([1-9]{2})|\+\+([1-9]{2})|([1-9]{2}))?(0|\(0\))?([1-9]\d{1})(\d{7,10})$/)) {
            valid = true;
        }

        return valid;
    }
});

Validator.extend('plz-switzerland', {
    getMessage: function(field, params, data) {
        return '';
    },
    validate: function(value) {
        value = value.replace(/ /g, '');
        value = value.replace(/\(/g, '');
        value = value.replace(/\)/g, '');

        let valid = false;
        if (value.match(/^(\d{4})$/)) {
            valid = true;
        }

        return valid;
    }
});

Validator.extend('plz-germany', {
    getMessage: function(field, params, data) {
        return '';
    },
    validate: function(value) {
        value = value.replace(/ /g, '');
        value = value.replace(/\(/g, '');
        value = value.replace(/\)/g, '');

        let valid = false;
        if (value.match(/^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/)) {
            valid = true;
        }

        return valid;
    }
});

Validator.extend('plz-france', {
    getMessage: function(field, params, data) {
        return '';
    },
    validate: function(value) {
        value = value.replace(/ /g, '');
        value = value.replace(/\(/g, '');
        value = value.replace(/\)/g, '');

        let valid = false;
        if (value.match(/^(?:[0-8]\d|9[0-8])\d{3}$/)) {
            valid = true;
        }

        return valid;
    }
});

Validator.extend('birthdate', {
    getMessage: function(field, params, data) {
        return '';
    },
    validate: function(value) {
        value = value.replace(/ /g, '');
        value = value.replace(/\(/g, '');
        value = value.replace(/\)/g, '');

        let valid = false;
        if (value.match(/^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.(19|20)\d\d$/)) {
            valid = true;
        }

        return valid;
    }
});

Validator.extend('password', {
    getMessage: function(field, params, data) {
        return '';
    },
    validate: function(password) {
        let hasSpecialChars = !(/^[a-zA-Z0-9- ]*$/.test(password));
        let hasNumber = /\d/.test(password);
        let lengthOk = password.length >= 8;

        return hasSpecialChars && hasNumber && lengthOk;
    }
});